
<template>
  <v-app id="searchVtwd">
    <v-main>
      <v-container fluid>  
        <v-card flat>
          <v-card-title>
            <v-row>Word translations<v-spacer></v-spacer><v-btn small color="primary" @click="addVtwd">add</v-btn></v-row>
          </v-card-title>
          <v-row cols="12" no-gutter dense class="ml-2">
            <v-col cols="3">
              <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify"
                  label="Search through all fields" single-line hide-detail />
            </v-col>
          </v-row>
          <v-data-table :headers="getHeaders()" :must-sort=true :items="searchVtwd" :search="search"
              :disable-pagination=true :loading="loading" :height="wInnerHeight" flat dense fixed-header
              loading-text="Loading data...please wait" no-data-text="No words to display" hide-default-footer>
              <template v-slot:item.vtwd_code="{ item }">
                  <span @click="openVtwd(item.vtwd_encrid)" class="clickable">{{ item.vtwd_code }}</span>
              </template>
              <template v-slot:item.vtwd_created="{ item }">
                  <span>{{ item.vtwd_display }}</span>
              </template>                        
          </v-data-table>       
        </v-card>  
      </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
    <add_vtwd ref="addVtwd" @updateData="updateData"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import add_vtwd from "@/components/syst/add_vtwd.vue";
 export default {
  components: {
    navBar,
    add_vtwd
  },
  data() {
    return {
      searchVtwd: [],
      wInnerHeight: window.innerHeight - 190,
      search:'',
      loading: false,      
    }  
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    window.addEventListener("resize", this.resizeEventHandler);
  },  
  mounted() {
      this.getVtwd()
      document.title = "ARES - Word Translations"
    },
    methods: {
      resizeEventHandler() {
        this.wInnerHeight = window.innerHeight - 190; // deduct estimated height for toolbar, searchfield and headers
      },      
      addVtwd(){
        this.$refs.addVtwd.open();
      },    
      updateData(data){
        console.log(data);
        data.field==='recid'?this.openVtwd(data.value):false;
      },      
      openVtwd(encrid){
        let route = this.$router.resolve({ path: `/syst/ref/vtwd/onVtwd/${encrid}`}); 
        window.open(route.href, '_blank');       
        this.getVtwd();
      },     
      getHeaders() {
        return [
            { text: "ID", value: "vtwd_code", sortable: false },
            { text: "Context", value: "vtwd_oms", sortable: true, width: '10%'},
            { text: "Created", value: "vtwd_created", sortable: true },
            { text: "Created by", value: "vtwd_user", sortable: false },
            { text: "NL", value: "vrtl[0].vrtl_vertaling", sortable: false },
            { text: "DE", value: "vrtl[1].vrtl_vertaling", sortable: false },
            { text: "EN", value: "vrtl[2].vrtl_vertaling", sortable: false },
            { text: "FR", value: "vrtl[3].vrtl_vertaling", sortable: false },
        ];
      },       
      getVtwd(){
        this.loading = true;
        this.$axios
            .post("ares/json/ares/syst/ref/vtwd/searchVtwd.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "searchVtwd"
                },
                searchVtwd: {
                }
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.searchVtwd = res.data.searchVtwd;
                    // console.log(this.searchVtwd);
                }
            })
            .finally(() => {
                this.loading = false;
            });
      },      
    }
};

</script> 

<style scoped>
    .clickable{
        color: blue;
        cursor: pointer;
    }
</style>